import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/acessogrupo?${serialize(filtros)}`, { tela: 'acesso_grupo' })
}

let resLayoutNovo = false
export async function layoutNovo () {
  if (!resLayoutNovo) resLayoutNovo = await httpAuth.get(`/acessogrupo/new`, { tela: 'acesso_grupo' })
  return resLayoutNovo
}

export async function get (id) {
  return httpAuth.get(`/acessogrupo/${id}`, { tela: 'acesso_grupo' })
}

export async function add (dados) {
  return httpAuth.post(`/acessogrupo`, dados, { funcionalidade: 'acesso_grupo_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/acessogrupo/${id}`, dados, { funcionalidade: 'acesso_grupo_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/acessogrupo/${id}`, { funcionalidade: 'acesso_grupo_excluir' })
}
